import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
// import { createUserWithEmailAndPassword, updateProfile, sendPasswordResetEmail } from 'firebase/auth'; // TODO: Refactor with Supabase Auth if needed
// import { doc, setDoc } from 'firebase/firestore'; // TODO: Refactor with Supabase DB if needed
// import { auth, firestore } from '../firebaseConfig'; // Firebase config removed

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Vérification du paiement...');
  const navigate = useNavigate();

  // Function to generate a secure random password
  const generateRandomPassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    let password = '';
    for (let i = 0; i < 16; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  // Create user account with information from payment
  const createUserAccount = async (email, planType, sessionId) => {
    // TODO: Refactor below logic with Supabase Auth/DB or remove if not applicable
    /*
    try {
      setMessage('Création de votre compte...');
      
      // Create Firebase user with random password
      const password = generateRandomPassword();
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Update display name (can use email prefix)
      const displayName = email.split('@')[0];
      await updateProfile(user, { displayName });
      
      // Create user document in Firestore
      await setDoc(doc(firestore, 'users', email), {
        email,
        name: displayName,
        uid: user.uid,
        planType: planType || 'myplum',
        paymentSessionId: sessionId,
        hasAccess: true,
        createdAt: new Date().toISOString()
      });
      
      // Send password reset email to let user set their own password
      await sendPasswordResetEmail(auth, email);
      
      setMessage('Compte créé avec succès! Redirection...');
      
      // Redirect to dashboard after successful creation
      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);
      
    } catch (error) {
      console.error('Error creating user account:', error);
      setStatus('error');
      setMessage('Erreur lors de la création du compte. Veuillez contacter le support.');
    }
    */
  };

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const session_id = searchParams.get('session_id');
        if (!session_id) {
          setStatus('error');
          setMessage('Session de paiement non trouvée');
          return;
        }

        // Call your API to verify the payment
        const response = await fetch('/api/verify-payment', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ session_id })
        });

        if (response.ok) {
          const { data } = await response.json();
          const { email, planType } = data;
          
          setStatus('success');
          setMessage('Paiement confirmé! Configuration de votre compte...');
          
          // Create user account with email from payment
          await createUserAccount(email, planType, session_id);
        } else {
          setStatus('error');
          setMessage('Erreur lors de la vérification du paiement');
        }
      } catch (error) {
        console.error('Verification error:', error);
        setStatus('error');
        setMessage('Une erreur est survenue');
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {(status === 'processing' || status === 'success') && (
          <div>
            <h2 className="text-2xl font-bold">
              {status === 'success' ? 'Paiement confirmé!' : 'Vérification du paiement...'}
            </h2>
            <p className="mt-2 text-gray-600">{message}</p>
            <div className="mt-6 flex justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary"></div>
            </div>
          </div>
        )}
        {status === 'error' && (
          <div>
            <h2 className="text-2xl font-bold text-red-600">Erreur de paiement</h2>
            <p className="mt-2">{message}</p>
            <p className="mt-2">Contactez le support si le problème persiste.</p>
            <button
              onClick={() => navigate('/')}
              className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Retour à l'accueil
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
